import { render, staticRenderFns } from "./allgoods.vue?vue&type=template&id=c3c610ea&scoped=true&"
import script from "./allgoods.vue?vue&type=script&lang=js&"
export * from "./allgoods.vue?vue&type=script&lang=js&"
import style0 from "./allgoods.vue?vue&type=style&index=0&id=c3c610ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c610ea",
  null
  
)

export default component.exports